package app.nestbridge.domain.identity.usecase

import app.nestbridge.domain.identity.model.ProfessionalProfile
import app.nestbridge.domain.identity.service.ProfessionalProfileService
import me.tatarka.inject.annotations.Inject

@Inject
class SaveProfessionalProfileUseCase(
    private val professionalProfileService: ProfessionalProfileService,
) {
    suspend operator fun invoke(profile: ProfessionalProfile): ProfessionalProfile =
        professionalProfileService.save(profile)
}
